import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchReset } from '../../actions/fetch.actions';

export const useLevelUnmount = (resourceKey) => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      // this will remove this level data from resources
      // when user moves to level up or down
      // ---
      // would be ideal if when going to level down state of this resource is not reset
      // but that would require extra work, lets keep it simple for now
      dispatch(fetchReset({ key: resourceKey }));
    };
  }, [dispatch, resourceKey]);
};
